import { ContextCurrencyFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { ActionTimelineFragment } from "../../../../../../../packages/wallet/src/components/ActionTimeline/ActionTimeline.fragment"
import { TokenRewardMediaFragment } from "../TreasureChestShareView/TokenRewardMedia.fragment"

export const TokenRewardCardFragment = graphql(
  `
    fragment TokenRewardCard on UserTokenReward {
      id
      address
      treasureChestId
      claimedAt
      airdrop
      ...TokenRewardMedia
      claimActions {
        actions {
          ...ActionTimeline
        }
      }
      balance {
        usdValue
        quantity
        currency {
          name
          symbol
          ...ContextCurrency
        }
      }
    }
  `,
  [ActionTimelineFragment, ContextCurrencyFragment, TokenRewardMediaFragment],
)
